var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var ShapeError = /** @class */ (function (_super) {
    __extends(ShapeError, _super);
    function ShapeError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ShapeError;
}(Error));
var isObject = function (value) {
    return typeof value === "object" && value !== null && !Array.isArray(value);
};
function object(value, path) {
    if (!isObject(value))
        throw new ShapeError("".concat(path || "definition", " is not an object"));
    return value;
}
function text(value, path) {
    if (typeof value !== "string")
        throw new ShapeError("".concat(path, " is not text"));
    return value;
}
function optional(value, read) {
    return value === undefined || value === null ? undefined : read(value);
}
function texts(value, path) {
    if (!Array.isArray(value))
        throw new ShapeError("".concat(path, " is not a list"));
    return value.map(function (item, index) { return text(item, "".concat(path, "[").concat(index, "]")); });
}
function textMap(value, path) {
    return Object.fromEntries(Object.entries(object(value, path)).map(function (_a) {
        var key = _a[0], item = _a[1];
        return [
            key,
            text(item, "".concat(path, ".").concat(key)),
        ];
    }));
}
function positive(value, path) {
    if (typeof value !== "number" || !Number.isFinite(value) || value <= 0) {
        throw new ShapeError("".concat(path, " is not a positive number"));
    }
    return value;
}
function decode(raw) {
    if (typeof raw !== "string")
        return raw;
    try {
        return JSON.parse(raw);
    }
    catch (_a) {
        throw new ShapeError("definition is not JSON");
    }
}
function attempt(read) {
    try {
        return { ok: true, value: read() };
    }
    catch (error) {
        if (error instanceof ShapeError)
            return { ok: false, problem: error.message };
        throw error;
    }
}
function selector(raw, path) {
    var value = object(raw, path);
    text(value.label, "".concat(path, ".label"));
    optional(value.options, function (options) { return textMap(options, "".concat(path, ".options")); });
    optional(value.default, function (fallback) { return text(fallback, "".concat(path, ".default")); });
    optional(value.when, function (when) {
        var condition = object(when, "".concat(path, ".when"));
        text(condition.selector, "".concat(path, ".when.selector"));
        texts(condition.in, "".concat(path, ".when.in"));
    });
    return value;
}
export function parseDashboard(raw) {
    return attempt(function () {
        var value = object(decode(raw), "");
        text(value.id, "id");
        text(value.title, "title");
        optional(value.description, function (description) { return text(description, "description"); });
        optional(value.section, function (section) { return text(section, "section"); });
        optional(value.requirements, function (requirements) { return texts(requirements, "requirements"); });
        optional(value.selectors, function (selectors) { return texts(selectors, "selectors"); });
        if (!Array.isArray(value.layout))
            throw new ShapeError("layout is not a list");
        value.layout.forEach(function (item, index) {
            var path = "layout[".concat(index, "]");
            var cell = object(item, path);
            text(cell.widget, "".concat(path, ".widget"));
            positive(cell.width, "".concat(path, ".width"));
            optional(cell.values, function (values) { return textMap(values, "".concat(path, ".values")); });
        });
        return value;
    });
}
export function parseWidget(raw) {
    return attempt(function () {
        var value = object(decode(raw), "");
        text(value.id, "id");
        text(value.title, "title");
        optional(value.description, function (description) { return text(description, "description"); });
        text(value.source, "source");
        optional(value.requirements, function (requirements) { return texts(requirements, "requirements"); });
        optional(value.follows, function (follows) { return texts(follows, "follows"); });
        optional(value.height, function (height) { return positive(height, "height"); });
        optional(value.selectors, function (selectors) {
            return Object.entries(object(selectors, "selectors")).forEach(function (_a) {
                var name = _a[0], item = _a[1];
                return selector(item, "selectors.".concat(name));
            });
        });
        return value;
    });
}
export function parseWidgets(entries) {
    return Object.fromEntries(Object.entries(entries !== null && entries !== void 0 ? entries : {}).map(function (_a) {
        var _b;
        var id = _a[0], entry = _a[1];
        var parsed = parseWidget(entry === null || entry === void 0 ? void 0 : entry.definition);
        var revision = (_b = entry === null || entry === void 0 ? void 0 : entry.revision) !== null && _b !== void 0 ? _b : 0;
        return [
            id,
            parsed.ok
                ? { widget: parsed.value, revision: revision }
                : { widget: null, revision: revision, problem: parsed.problem },
        ];
    }));
}
